import Vue from 'vue';
import VueRouter from 'vue-router';
/* eslint-disable no-unused-vars */
import {siteRouters, dashboardRouters} from './routers-map';

Vue.use(VueRouter);

const routes = [...siteRouters, ...dashboardRouters];

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes,
   scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve,) => {
         setTimeout(() => {
            resolve(savedPosition || {x: 0, y: 0})
         }, 200)
      })
   }
});

router.beforeEach(async (to, from, next) => {
   if (to.fullPath === '/buscar/?dates=&coord=-52.42583,-29.7175&utm_source=Flyer%20Santa%20Cruz&utm_medium=Flyer%20Santa%20Cruz&utm_campaign=Flyer%20Santa%20Cruz&utm_id=Flyer%20SC') {
      next('/bicicletas/Santa-Cruz-do-Sul?&utm_source=Flyer%20Santa%20Cruz&utm_medium=Flyer%20Santa%20Cruz&utm_campaign=Flyer%20Santa%20Cruz&utm_id=Flyer%20SC');
      return
   }

   const publicPages = [
      'login',
      'recover-password',
      'recover-password-token',
      'recover-password-token-id',
      'register',
      'home',
      'about',
      'help',
      'ads-your-bike',
      'how-works',
      'politics',
      'bike',
      'search',
      'contact',
      'advertiser-owner',
      'advertiser-customer',
      'advertiser'
   ];
   const authRequired = !publicPages.includes(to.name);
   const loggedIn = localStorage.getItem('user');

   // trying to access a restricted page + not logged in
   // redirect to login page
   if (authRequired && !loggedIn && !to.params.token && !to.params.email) {
      next('/login');
   } else {
      next();
   }
});

export default router
